function labelNumberFilter() {
    'ngInject';

    return function (input, labels) {
        let response = input;
        if (labels[input]) {
            response = labels[input];
        }
        return response;
    };
}

angular
    .module('BB')
    .filter('labelNumber', labelNumberFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/label_number.filter.js